// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"175b3cce","372":"32cb6cf5"}[chunkId] + ".css";
};